import { Box } from "@mui/material"
import { ShopItem } from "./ShopItem";

export const ShopItemList = ({ shopItems = [] }) => {
    return (
        <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
            gap: '8px',
        }}>
            {shopItems.map((si, ix) => <ShopItem key={ix} shopItem={si} />)}
        </Box>
    );
}